import React, { useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import ClassicEditor from "ckeditor-c-build/ckeditor";
import ClassicEditor from "ckeditor-hashure-build/ckeditor";

const CkEditor = (props) => {
  const { form, field } = props;

  return (
    <div className="col-span-2">
      <label className="leading-2 text-white mb-3">{props.label}</label>
      <CKEditor
        editor={ClassicEditor}
        data={props.field.value}
        toolbarStyle={{
          backgroundColor: "#313a55",
          border: "1px solid #6b7280",
        }}
        editorStyle={{
          backgroundColor: "#313a55",
          color: "white",
          minHeight: "200px",
        }}
        wrapperStyle={{
          backgroundColor: "#313a55",
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          form.setFieldValue(field.name, data);
        }}
      />

      <style jsx global>{`
        .rdw-c-wrapper-class,
        .editor-class,
        .toolbar-class {
          background: #313a55;
          color: white;
        }
        .rdw-option-wrapper {
          background: #313a55 !important;
        }
        .ck .ck-button__label {
          color: white !important;
        }
      `}</style>
    </div>
  );
};

export default CkEditor;
